import React from "react";
import Title from "../header/Title";
import { Box, Button } from "@mui/material";
import { Link } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import ListCollection from "./ListCollection";

const Collections: React.FC = () => {
  return (
    <React.Fragment>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Title title="Collections" subtitle="Managing the Product Collections" />
        <Box>
          <Button
            variant="contained"
            component={Link}
            to="/AddCollection"
            sx={{ fontSize: "14px", padding: "10px 12px" }}
          >
            <AddIcon sx={{ mr: "4px" }} />
            Add New
          </Button>
        </Box>
      </Box>
      <ListCollection />
    </React.Fragment>
  );
};

export default Collections;
